// import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const EXCEPTION: AppRouteRecordRaw = {
  path: '/board',
  name: 'boardCreate',
  meta: {
    locale: '测试看板拖拽',
    icon: 'icon-exclamation-circle',
    order: 6,
    hideInMenu: true
  },
  children: [
    {
      path: 'create',
      name: 'create',
      meta: {
        ignoreCache: true
      },
      component: () => {
        return import('@/views/dashboard/dashboardCreate/index.vue');
      }
    },
    {
      path: 'edit',
      name: 'edit',
      meta: {
        ignoreCache: true
      },
      component: () => {
        return import('@/views/dashboard/dashboardCreate/index.vue');
      }
    },
    {
      path: 'item',
      component: () => {
        return import('@/views/dashboard/list/_components/Content/index.vue');
      },
      meta: {
        menu: false,
        noDesc: true
      }
    }
  ]
};

export default EXCEPTION;
